// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { PaginationTokens } from './type';

const paginationTokens: PaginationTokens = {
  paginationFontSize: '14/regular',
  paginationSmallFontSize: '12/regular',
  paginationLargeFontSize: '16/regular',
  paginationFontColor: 'Neutral-text-5',
  paginationNearlyMargin: 'Margin-8',
};

export default paginationTokens;
